
export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Enhanced Security',
      description: 'Military-grade encryption and advanced security protocols protect your data and privacy at all times. Our applications implement the latest security standards to ensure your information remains safe.',
      size: 'large'
    },
    {
      icon: 'ri-speed-line',
      title: 'High Performance',
      description: 'Optimized code and efficient algorithms ensure smooth operation and minimal battery consumption. Experience lightning-fast performance without compromising device resources.',
      size: 'large'
    },
    {
      icon: 'ri-user-smile-line',
      title: 'User-Friendly Interface',
      description: 'Intuitive design that makes complex features accessible to everyone',
      size: 'small'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Regular Updates',
      description: 'Continuous improvements and new features based on user feedback',
      size: 'small'
    },
    {
      icon: 'ri-customer-service-line',
      title: '24/7 Support',
      description: 'Dedicated support team ready to assist you whenever you need help',
      size: 'small'
    }
  ];

  return (
    <section id="features" className="py-32 bg-gray-50">
      <div className="max-w-[1400px] mx-auto px-20">
        <div className="text-center space-y-6 mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-100 rounded-full">
            <i className="ri-star-line text-teal-600 text-base"></i>
            <span className="text-sm font-medium text-teal-600 whitespace-nowrap">Key Features</span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900">
            Designed for Security & Performance
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our applications are built with cutting-edge technology to deliver exceptional user experience
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
          {features.slice(0, 2).map((feature, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-br from-teal-50 to-emerald-50 rounded-3xl p-12 transition-all duration-300 hover:shadow-2xl overflow-hidden"
            >
              <div className="absolute top-1/2 right-12 transform -translate-y-1/2 opacity-5">
                <i className={`${feature.icon} text-[180px] text-teal-600`}></i>
              </div>
              
              <div className="relative space-y-6">
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-teal-600 to-emerald-600 rounded-2xl shadow-lg">
                  <i className={`${feature.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-3xl font-bold text-gray-900">{feature.title}</h3>
                <p className="text-lg text-gray-700 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.slice(2).map((feature, index) => (
            <div
              key={index}
              className="group bg-white rounded-3xl p-10 shadow-lg transition-all duration-300 hover:shadow-2xl hover:-translate-y-2"
            >
              <div className="text-center space-y-6">
                <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-teal-100 to-emerald-100 rounded-2xl mx-auto">
                  <i className={`${feature.icon} text-4xl text-teal-600`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">{feature.title}</h3>
                <p className="text-base text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-50 rounded-full">
                  <span className="text-sm font-semibold text-teal-600 whitespace-nowrap">Learn More</span>
                  <i className="ri-arrow-right-line text-teal-600"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}